import {
	Component,
	Input,
	Output,
	OnDestroy,
	OnChanges,
	EventEmitter
} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { FileUploadServiceProvider } from '@services/files/file-upload-service/file-upload.service';
import { MessageService } from '@services/helpers/message-service/message.service';

@Component({
	selector: 'attachments',
	template: require('./attachments.html')
})
export class AttachmentsComponent implements OnDestroy, OnChanges {
	@Input() filesObj: any;
	@Output() attachmentsChanged: EventEmitter<any> = new EventEmitter<any>();
	files: any = null;

	attachmentsView: Array<any> = [];
	unsubscribe: Subject<void> = new Subject<void>();

	constructor(
		private fileUploadService: FileUploadServiceProvider,
		private messageService: MessageService
	) {}

	ngOnChanges() {
		if (this.filesObj !== undefined) {
			this.attachmentsView = this.filesObj.attachments;
			this.handleAttachmentsView(this.attachmentsView);
		}
	}

	ngOnDestroy() {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	renewFiles(event): void {
		if (event && event.target.files) {
			let newFile = event.target.files[0];
			newFile = this.fileUploadService.addFileConvertedSize(newFile);
			this.attachmentsView.push(newFile);
			this.handleAttachmentsView(this.attachmentsView, newFile);
		}
	}

	removeAttachment(index): void {
		this.attachmentsView.splice(index, 1);
		this.handleAttachmentsView(this.attachmentsView);
	}

	private handleAttachmentsView(attachmentsView, newFile?): void {
		if (attachmentsView && attachmentsView.length > 0) {
			const resultSize = this.fileUploadService.getTotalSize(attachmentsView);
			const maxSize: number = this.fileUploadService.maxAttachment;

			if (resultSize > maxSize) {
				this.messageService.showToaster('w_0', 'attachments');
				if (typeof newFile !== 'undefined') {
					attachmentsView.pop(newFile);
					return;
				}
			}

			this.filesObj.filesSize = resultSize;
			this.filesObj.attachments = attachmentsView;
			this.attachmentsChanged.emit(this.filesObj);
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./mobile/src/components/files/attachments/attachments.ts